 (function () {
  "use strict";

  function normalizeFabricCode(value) {
    return String(value || "")
      .trim()
      .toUpperCase()
      .replace(/\s+/g, "");
  }

  function getFabricFamily(fabricCode) {
    const code = normalizeFabricCode(fabricCode);
    const match = code.match(/^[A-Z]+/);

    if (!match) {
      return null;
    }

    const family = match[0];

    if (
      !window.RA_DEALER_FABRICS ||
      !Object.prototype.hasOwnProperty.call(window.RA_DEALER_FABRICS, family)
    ) {
      return null;
    }

    return family;
  }

  function isTrousersOnlyFabric(fabricCode) {
    const code = normalizeFabricCode(fabricCode);

    return Boolean(
      window.RA_TROUSERS_ONLY_CODES &&
      window.RA_TROUSERS_ONLY_CODES.has(code)
    );
  }

  function normalizeGarmentType(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function getGarmentPriceKey(garmentType) {
    const garment = normalizeGarmentType(garmentType);

    if (
      garment.includes("three piece") ||
      garment.includes("3 piece")
    ) {
      return "threePiece";
    }

    if (
      garment === "suit" ||
      garment.includes("two piece") ||
      garment.includes("2 piece")
    ) {
      return "twoPiece";
    }

    if (
      garment.includes("sport jacket") ||
      garment.includes("sports jacket")
    ) {
      return "sportJacket";
    }

    if (
      garment.includes("trouser") ||
      garment.includes("pants")
    ) {
      return "trousers";
    }

    if (
      garment.includes("vest") ||
      garment.includes("waistcoat")
    ) {
      return "vest";
    }

    return null;
  }

  function isFabricAllowedForGarment(fabricCode, garmentType) {
    const priceKey = getGarmentPriceKey(garmentType);

    if (!priceKey) {
      return false;
    }

    if (isTrousersOnlyFabric(fabricCode)) {
      return priceKey === "trousers";
    }

    return true;
  }

  function getFabricPrices(fabricCode) {
    const family = getFabricFamily(fabricCode);

    if (!family) {
      return null;
    }

    return window.RA_DEALER_FABRICS[family];
  }

  function getDealerFabricPrice(fabricCode, garmentType) {
    if (!isFabricAllowedForGarment(fabricCode, garmentType)) {
      return null;
    }

    const prices = getFabricPrices(fabricCode);
    const priceKey = getGarmentPriceKey(garmentType);

    if (!prices || !priceKey) {
      return null;
    }

    const price = prices[priceKey];

    return Number.isFinite(price) ? price : null;
  }

  window.RADealerFabricPricing = {
    normalizeFabricCode,
    getFabricFamily,
    isTrousersOnlyFabric,
    normalizeGarmentType,
    getGarmentPriceKey,
    isFabricAllowedForGarment,
    getFabricPrices,
    getDealerFabricPrice
  };
})();